module.exports = __webpack_public_path__ + "static/media/WI3.8731292c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/WI/WI3.png
// module id = 740
// module chunks = 0